import { useReducer} from "react";
import '../ConfigPayroll/PayrollGroup.css'
import { Grid } from "@material-ui/core";
import { useToggle } from '../../hooks/useToggle';
import MenuListPerception from "./Modals/MenuListPerception";
import InfoPerception from '../ConfigPayroll/Modals/InfoPerceptionModal';
import EliminaPerception from "./Modals/EliminaPerception";
import EditaPerception from "./Modals/EditaPerception";
import { TabPerceptionContext } from '../../context/ConfigPayrollContext/TabPerceptionContext';
import CrearPerceptionModal from "./Modals/CrearPerceptionModal";
import { TabPerceptionReducer } from "../../context/ConfigPayrollContext/TabPerceptionReducer";
import { useQuery, useMutation } from "@apollo/client";
import { 
  GET_ALL_PERCEPTIONS, 
  UPDATE_PERCEPTION_STATUS, 
  GET_ALL_PERCEPTIONS_CALENDAR,
  GET_ALL_PERCEPTIONS_INCIDENCIAS
} from "../../Querys/querys";
import GreenSwitch from './GreenSwitch'
import CheckPermission from "../../helpers/Administradores/Permissions";


interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
};

const PerceptionTable = (props: TabPanelProps) =>{
    const resultPerceptions = useQuery(GET_ALL_PERCEPTIONS);
    const allPerceptions = resultPerceptions.data?.GET_ALL_PERCEPTIONS;
    const [PerceptionState, PerceptionDispatch,] = useReducer(TabPerceptionReducer, { loading: true, Perceptions: [], PerceptionsFilter: [] });
    const [inactiveOpen, setInactiveOpen] = useToggle(false);
    const [addPerceptionOpen, setAddPerceptionOpen] = useToggle(false);
    const [updateStatus] = useMutation(UPDATE_PERCEPTION_STATUS,{
      refetchQueries:[
                      {query: GET_ALL_PERCEPTIONS},
                      {query: GET_ALL_PERCEPTIONS_CALENDAR},
                      {query: GET_ALL_PERCEPTIONS_INCIDENCIAS},
                    ]
    })

    const updatePayrollStatus = (id:any) =>{
      updateStatus({
        variables:{
          updatePerceptionStatusId: id
        }
      })
    }

    return(
      <>
        <div className="contenedorHeader">
            <div>
              <span className="tituloHeader">Percepciones</span>
            </div>
            {CheckPermission("ConfiguracionNominas.Conceptos.Percepciones.Crear") && ( 
            <div>
            <TabPerceptionContext.Provider value={{
                        inactiveOpen,
                        setInactiveOpen,
                        addPerceptionOpen,
                        setAddPerceptionOpen,
                        PerceptionState,
                        PerceptionDispatch
                    }}>
              <button onClick={setAddPerceptionOpen} className="botonHeader">
                <div className='contenedorBotonHeader'>
                  <div className="textoBotonHeader">
                    <span>+ Nueva Percepción</span>
                  </div>
                </div>
              </button>  
              <CrearPerceptionModal />
                </TabPerceptionContext.Provider>             
            </div>)} 
          </div>
          <div className="contenedorTabla">
            <div className="contenedorTituloTabla">
            <Grid container spacing={1}>
                <Grid item xs={4} className="tituloTabla">
                  <span className="textotituloTabla">Nombre</span>
                </Grid>
                <Grid item xs={3} className="tituloTabla">
                  <span className="textotituloTabla">Clave SAT</span>
                </Grid>
                <Grid item xs={4} className="tituloTabla">
                  <span className="textotituloTabla">Estatus</span>
                </Grid>
                <Grid item xs={1} className="tituloTabla">
                  <span className="textotituloTabla">Más información</span>
                </Grid>
              </Grid>
            </div>
          </div>
          <div>
            <ul>
              {allPerceptions?.map((lis:any) =>
                <li className="listaTabla">
                  <Grid container spacing={1}>
                    <Grid item xs={4} className="tituloTabla">
                      <div className="tablaColumnaFlex">
                        <span className="textoTabla">{lis.ConceptName}
                                                     { (lis.SATKey !== "016" || lis.ConceptName ==="Vacaciones pagadas" || lis.ConceptName ==="Días económicos"  ) && ' *'}</span>
                      </div>
                    </Grid>
                    <Grid item xs={3} className="tituloTabla">
                      <div className="tablaColumnaFlex">
                        <span className="textoTabla">{lis.SATKey}</span>
                      </div>
                    </Grid>
                    <Grid item xs={4} className="tituloTabla">
                    <div className="tablaColumnaFlex">
                        <div className="tablaColumnaFlex">
                          <div className="columnaEstatus">
                            <div>
                              <span className="textoTabla">{lis.statusPerceptions}</span>
                            </div>
                            <div>
                              <GreenSwitch updatePayrollStatus={updatePayrollStatus} id={lis.id} status={lis.statusPerceptions}/>
                            </div>
                          </div>
                        </div>
                      <div className="menuTabla">
                      <MenuListPerception  
                      {...{ 
                        _id:lis.id, 
                        ConceptName: lis.ConceptName, 
                        SATKey: lis.SATKey, 
                        ConceptType: lis.Concept_Type, 
                        AccountingAccount: lis.AccuntingAccount, 
                        PayType: lis.PayType, 
                        ISRTax: lis.ISRTax, 
                        ISNTax: lis.ISNTax, 
                        SocialSecurity: lis.SocialSecurity,
                        IntegratesIMSS: lis.IntegratesIMSS, 
                        gravaISR: lis.gravaISR,
                        time: lis.time,
                        isMoney: lis.isMoney,
                        muestraCalendario: lis.muestraCalendario,
                        noDelete: lis.noDelete
                        } }
                      />
                      </div>
                    </div>
                    </Grid>
                  </Grid>
                </li>
            )
            }
        </ul>
            <InfoPerception />
            <EditaPerception />
            <EliminaPerception />
            </div>
        </>
    )
}
 
export default PerceptionTable